import React from 'react';
import {
	ExperienceStart,
	ExperienceSuccess,
	useExperienceFail,
} from '@atlassian/jira-experience-tracker';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller';

const EXPERIENCE_NAME = 'viewFeatureFlagsEmptyStateExperience';

export const ViewFeatureFlagsEmptyStateExperienceExperienceStart = ({
	experienceId,
}: {
	experienceId: string | null;
}) => {
	const appEditions = useAppEditions();
	return (
		<ExperienceStart
			experienceId={experienceId}
			experience={EXPERIENCE_NAME}
			analyticsSource="featureFlagsEmptyStateExperience"
			edition={appEditions.software}
			application={JIRA_SOFTWARE}
		/>
	);
};

export const useViewFeatureFlagsEmptyStateExperienceExperienceFail = () =>
	useExperienceFail({ experience: EXPERIENCE_NAME });

export const ViewFeatureFlagsEmptyStateExperienceExperienceSuccessTracker = () => {
	const { data: projectContext } = useProjectContext();

	return (
		<ExperienceSuccess
			experience={EXPERIENCE_NAME}
			attributes={
				projectContext != null
					? {
							projectId: projectContext.projectId,
							isProjectAdmin: projectContext.isProjectAdmin,
							simplified: projectContext.simplified,
						}
					: undefined
			}
		/>
	);
};
